import styled from '@emotion/styled'
import {
  colors,
  DialogContent,
  DialogTitle,
  typography,
  Button as BirdsongButton,
  Alert,
} from '@resiliatech/birdsong'
import { Popover as MuiPopover } from '@material-ui/core'

export const Popover = styled(MuiPopover)`
  .MuiPopover-paper {
    width: 100%;
    max-width: 600px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 300px;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`

export const Title = styled(DialogTitle)`
  padding: 0 16px;
  margin: 0;
`

export const StyledDialogContent = styled(DialogContent)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  margin: 0;
`

export const MessageBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`

export const StyledButton = styled(BirdsongButton)<{
  $variant?: 'primary' | 'error'
}>`
  ${typography.baseline.semiBoldSans}
  padding: 8px 22px;
  min-width: 100px;
  && {
    background-color: ${({ $variant }) =>
      $variant === 'error'
        ? colors.feedback.errorDark
        : colors.interactive.primaryEnabled};
    color: ${colors.common.white};
    &:hover {
      background-color: ${({ $variant }) =>
        $variant === 'error'
          ? colors.feedback.errorDark
          : colors.interactive.primaryEnabled};
    }
  }
`

export const ActionButton = styled.div`
  align-items: center;
  display: flex;
  color: ${colors.interactive.primaryEnabled};
  cursor: pointer;
`

export const StyledAlert = styled(Alert)<{ severity: 'success' | 'error' }>`
  width: 100%;
  margin: 0;
  background-color: ${({ severity }) =>
    severity === 'success'
      ? colors.feedback.successLight
      : colors.feedback.errorLight};
`
